module.exports = __webpack_public_path__ + "static/bbva-9a23544bc923681d76996887163a11d9.png";